import { SearchSort } from "@aipb/gulliver/castor/model";
import { CastorMapper } from './mapper';

export class SearchSortMapper implements CastorMapper<SearchSort[]> {
  map(o: SearchSort[]): { [p: string]: any } {
    if (!o || o.length === 0) return {};

    return {
      sort: o.map((s) => `${s.field} ${s.dir} ${s.lang}`).join(',')
    };
  }
}
